import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import SectionsList from './SectionsList/SectionsList';
import SectionShow from './SectionShow/SectionShow';
import SectionEdit from './SectionEdit/SectionEdit';
import SectionCreate from './SectionCreate/SectionCreate';
import SectionDelete from './SectionDelete/SectionDelete';

const Sections = ({ match }) => {
    return (
        <div className="Sections">
            <ContainerWrapper container="sections">
                <Route exact path={ match.path } component={SectionsList} />
                <Route exact path={ `${ match.url }/new` } component={SectionCreate} />
                <Route exact path={ `${ match.url }/show/:sectionId` } component={SectionShow} />
                <Route exact path={ `${ match.url }/edit/:sectionId` } component={SectionEdit} />
                <Route exact path={ `${ match.url }/delete/:sectionId` } component={SectionDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Sections;
